<ng-template [ngIf]="showPopupDownload">
  <div (swipedown)="hideDownloadPopup()" class="wrapper-download-popup" [@.disabled]="device.isDisableAnimation()">
    <div [@fading]="slideAnimationFadingPopupDownload" id="container-popup-download" (click)="hideDownloadPopup()">
    </div>
    <div [@slidePopupDownload]="slideAnimationPopupDownload" (@slidePopupDownload.done)="onSlidePopupDownload($event)"
         (@slidePopupDownload.start)="onSlideStartPopupDownload($event)" id="wrapper-download">
      <div class="container-close">
        <navaar-close-icon (click)="hideDownloadPopup()" [color]="'#9D9CA0'" [style]="{
                        display: 'inline-block',
                        width: '30px',
                        height: '10px',
                        padding:' 10px',
                        'box-sizing': 'content-box'}"></navaar-close-icon>
      </div>
      <div class="wrapper-image">
        <img alt="cover-book"
             [src]="environment.imageUrl + '/content/books/' + dataBook.audioBookId + '/pic.jpg?t=' + dataBook.recordVersion  + '&w=250&h=250'">
      </div>
      <ng-template [ngIf]="isLogin" [ngIfElse]="not_login">
        <div *ngIf="purchase?.discounts" class="container-price-discount">
          <ng-template ngFor [ngForOf]="purchase.discounts" let-discountItem let-index="index">
            <div>
              <span class="main-price"
                    [textContent]="((index== 0) ? getMainPriceForDiscount() : calculateDiscount(index)) | number:'1.0-0'"></span>
              <span class="badge-discount">
                %{{(discountItem.discountPercentage * 100 | number:'1.0-0')}}
              </span>
            </div>
          </ng-template>
        </div>
        <ng-template [ngIf]="purchase?.description?.length > 0" [ngIfElse]="price_section">
          <p class="text-has-in-library" [textContent]="purchase?.description"></p>
        </ng-template>
<!--        <ng-template [ngIf]="purchase.purchaseButtonState.purchaseButtonAction == purchaseButtonActionType.library ||-->
<!--                              purchase.purchaseButtonState.purchaseButtonAction == purchaseButtonActionType.Archived"-->
<!--                     [ngIfElse]="price_section">-->
<!--          <p class="text-has-in-library" [textContent]="purchase?.description"></p>-->
<!--        </ng-template>-->
        <ng-template #price_section>
          <div class="container-price" *ngIf="purchase?.purchaseButtonState?.stateDiscountedPrice" [ngStyle]="{
                  visibility:!(purchase.purchaseButtonState.purchaseButtonAction == purchaseButtonActionType.library ||
                               purchase.purchaseButtonState.purchaseButtonAction == purchaseButtonActionType.getFree) ? 'visible' : 'hidden'
              }">
            <p *ngIf="purchase?.discounts">قیمت با احتساب تخفیف</p>
            <b [textContent]="purchase.purchaseButtonState?.stateDiscountedPrice | number:'1.0-0'"></b>
            <span>تومان</span>
          </div>
        </ng-template>
        <div class="container-btns">
          <ng-template
            [ngIf]="(
              purchase?.newSubscriptionButtonState?.subscriptionButtonState === subscriptionButtonStateType.noSubscription ||
              purchase?.newSubscriptionButtonState?.subscriptionButtonState === subscriptionButtonStateType.getBySubscription ||
              purchase?.newSubscriptionButtonState?.subscriptionButtonState === subscriptionButtonStateType.intervalQuotaHasFinished ||
              purchase?.newSubscriptionButtonState?.subscriptionButtonState === subscriptionButtonStateType.playByNewSubscription)">
            <div class="wrapper-btn">
              <navaar-button
                [disabled]="purchase.newSubscriptionButtonState.subscriptionButtonState == subscriptionButtonStateType.intervalQuotaHasFinished"
                [type-button]="'button'" [color-name]="'orange'" (onClick)="goToSubscription(purchase?.newSubscriptionButtonState?.subscriptionButtonState)">
                <div>
                  <navaar-play-icon
                    *ngIf="purchase?.newSubscriptionButtonState?.subscriptionButtonState === subscriptionButtonStateType.playByNewSubscription"></navaar-play-icon>
                  <span [textContent]="purchase.newSubscriptionButtonState.subscriptionButtonText"></span>
                </div>
              </navaar-button>
            </div>
          </ng-template>
          <ng-template [ngIf]="(purchase?.subscriptionButtonState?.subscriptionButtonState == subscriptionButtonStateType.noSubscription ||
                  purchase?.subscriptionButtonState?.subscriptionButtonState == subscriptionButtonStateType.getBySubscription ||
                  purchase?.subscriptionButtonState?.subscriptionButtonState == subscriptionButtonStateType.intervalQuotaHasFinished)">
            <div class="wrapper-btn">
              <navaar-button
                [disabled]="purchase.subscriptionButtonState.subscriptionButtonState == subscriptionButtonStateType.intervalQuotaHasFinished"
                [type-button]="'button'"
                [color-name]="'subscription'"
                (onClick)="goToSubscription(purchase?.subscriptionButtonState?.subscriptionButtonState)"
              >
                  <span
                    id="subscriptionButtonState-span"
                    [textContent]="purchase.subscriptionButtonState.subscriptionButtonText"
                  ></span>
              </navaar-button>
            </div>
          </ng-template>
          <ng-template [ngIf]="appParameterService.clientId ===  clientType.iGap ? purchase?.pdpActionButtonState?.showPurchaseButton !== false : true">
            <ng-template
              [ngIf]="purchase?.purchaseButtonState?.purchaseButtonAction != purchaseButtonActionType.disabled">
              <div class="wrapper-btn">
                <navaar-button
                  [type-button]="'button'"
                  [color-name]="getClassName()"
                  (onClick)="onPurchase()"
                >
                  <span [textContent]="purchase.purchaseButtonState.purchaseButtonText"></span>
                </navaar-button>
              </div>
            </ng-template>
          </ng-template>
        </div>
      </ng-template>
      <ng-template #not_login>
        <div class="container-price-discount">
          <div *ngIf="product.discount">
            <span class="main-price" [textContent]="(product.price / 10) | number:'1.0-0'"></span>
            <span class="badge-discount">
              %{{(product.discount.promotionValue * 100 | number:'1.0-0')}}
            </span>
          </div>
          <div class="container-price">
            <p *ngIf="product.discount">قیمت با احتساب تخفیف</p>
            <b [textContent]="((product.discount ? product.discountedPrice : product.price) / 10) | number:'1.0-0'"></b>
            <span>تومان</span>
          </div>
          <div class="container-btns">
            <div class="wrapper-btn">
              <navaar-button [type-button]="'button'" [color-name]="'blue'" (onClick)="device.goTologinPageNative()">
                <span>ورود و دریافت</span>
              </navaar-button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>
